import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();


  const pc = 768;
  let rellax = null;

  const setupRellax = () => {
    const windowWidth = window.innerWidth;

    if (windowWidth > pc) {
      if (!rellax) {
        rellax = new Rellax('.rellax', {
          round: true,
        });
      }
      return;
    }

    if (rellax) {
      rellax.destroy();
      rellax = null;
    }
  };

  setupRellax();
  window.addEventListener('resize', setupRellax);


  const lenis = new Lenis();
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);



  const initAnimationText = () => {
    const targets = document.querySelectorAll('.animation-text');
    if (!targets.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    targets.forEach((target) => {
      if (target.dataset.animationTextReady === 'true') return;

      const textNodes = [];
      const walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
      }

      let charIndex = 0;
      textNodes.forEach((node) => {
        if (!node.textContent || node.textContent.length === 0) return;

        const fragment = document.createDocumentFragment();
        [...node.textContent].forEach((char) => {
          const charSpan = document.createElement('span');
          charSpan.className = 'animation-text-char';
          charSpan.style.setProperty('--char-delay', `${charIndex * 0.06}s`);
          charSpan.textContent = char === ' ' ? '\u00A0' : char;
          fragment.appendChild(charSpan);
          charIndex += 1;
        });
        node.parentNode.replaceChild(fragment, node);
      });

      target.dataset.animationTextReady = 'true';

      if (prefersReducedMotion) {
        target.classList.add('is-animated');
      }
    });

    if (prefersReducedMotion) return;

    const io = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-animated');
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -20% 0px',
        threshold: 0,
      }
    );

    targets.forEach((target) => {
      io.observe(target);
    });
  };

  initAnimationText();



  if (document.body.classList.contains('contact') ) {
    topValidation();
  }

  const header = document.querySelector('.header');

  if (header) {
    const headerToggle = document.querySelector('.hd_toggle');
    const headerLinks = document.querySelector('.hd_links');
    const mobileMediaQuery = window.matchMedia('(max-width: 768px)');

    if (headerToggle && headerLinks) {
      const openMenu = () => {
        header.classList.add('is-open');

        // Transition cannot animate to/from auto, so expand with pixel height first.
        headerLinks.style.height = '0px';
        requestAnimationFrame(() => {
          headerLinks.style.height = `${headerLinks.scrollHeight}px`;
        });
      };

      const closeMenu = () => {
        // If currently auto, lock to pixel height before collapsing to 0.
        headerLinks.style.height = `${headerLinks.scrollHeight}px`;
        void headerLinks.offsetHeight;
        header.classList.remove('is-open');
        requestAnimationFrame(() => {
          headerLinks.style.height = '0px';
        });
      };

      const syncMenuForViewport = () => {
        if (!mobileMediaQuery.matches) {
          header.classList.remove('is-open');
          headerLinks.style.height = '';
          return;
        }

        if (header.classList.contains('is-open')) {
          headerLinks.style.height = 'auto';
        } else {
          headerLinks.style.height = '0px';
        }
      };

      headerToggle.addEventListener('click', () => {
        if (header.classList.contains('is-open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      headerLinks.addEventListener('transitionend', (event) => {
        if (event.propertyName !== 'height') return;
        if (header.classList.contains('is-open')) {
          headerLinks.style.height = 'auto';
        }
      });

      window.addEventListener('resize', syncMenuForViewport);
      syncMenuForViewport();
    }

    const isFrontPage = document.body.classList.contains('home') || document.body.classList.contains('front-page');
    const isMobileWidth = window.matchMedia('(max-width: 768px)').matches;

    if (!isFrontPage || isMobileWidth) {
      header.classList.add('is-fixed');
    } else {
      let unfixTimer = null;

      const startUnfix = () => {
        if (!header.classList.contains('is-fixed') || header.classList.contains('is-unfixing')) return;

        header.classList.add('is-unfixing');
        if (unfixTimer) clearTimeout(unfixTimer);
        unfixTimer = setTimeout(() => {
          header.classList.remove('is-fixed', 'is-unfixing');
          unfixTimer = null;
        }, 400);
      };

      const keepFixed = () => {
        if (unfixTimer) {
          clearTimeout(unfixTimer);
          unfixTimer = null;
        }
        header.classList.remove('is-unfixing');
        header.classList.add('is-fixed');
      };

      const toggleHeaderFixed = () => {
        const fixedPoint = window.innerHeight;
        if (window.scrollY >= fixedPoint) {
          keepFixed();
        } else {
          startUnfix();
        }
      };

      toggleHeaderFixed();
      window.addEventListener('scroll', toggleHeaderFixed);
    }
  }




  let els = document.querySelectorAll('.js-fadeIn');

  function checkFadeIn() {
    let windowHeight = window.innerHeight;

    els.forEach(function(el) {
      if (el.classList.contains('is-scrollIn')) return;

      let rect = el.getBoundingClientRect();

      if (rect.top < windowHeight - 250) {
        el.classList.add('is-scrollIn');
      }
    });
  }

  window.addEventListener('scroll', checkFadeIn);
  window.addEventListener('load', checkFadeIn);
  checkFadeIn();


  // 子要素をディレイ付きで表示
  let parents = document.querySelectorAll('.js-fade-parent');

  function checkParentFade() {
    let windowHeight = window.innerHeight;

    parents.forEach(function(parent) {
      if (parent.classList.contains('is-shown')) return;

      let rect = parent.getBoundingClientRect();

      // 親が画面内に入ったら
      if (rect.top < windowHeight - 250) {
        parent.classList.add('is-shown');

        let children = parent.querySelectorAll('.js-fade-child');

        children.forEach(function(child, index) {
          setTimeout(function() {
            child.classList.add('is-scrollIn');
          }, index * 250);
        });
      }
    });
  }

  window.addEventListener('scroll', checkParentFade);
  window.addEventListener('load', checkParentFade);
  checkParentFade();


});
